import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {SharedModule} from 'src/app/shared/shared.module';
import {LeftSideNavigationComponent} from './left-side-navigation.component';
import {MatListModule} from '@angular/material/list';
import {MatIconModule} from '@angular/material/icon';
import {RouterModule} from '@angular/router';


@NgModule({
  declarations: [
    LeftSideNavigationComponent
  ],
  imports: [
    CommonModule,
    SharedModule,
    MatListModule,
    MatIconModule,
    RouterModule
  ],
  exports: [
    LeftSideNavigationComponent
  ],
})
export class LeftSideNavigationModule {
}
